<template>

  <div id="portfolio" class="position-relative">
    <!-- <transition name="slide-fade" mode="in-out"> -->
    <transition name="fade">
      <modal v-if="showModal" @close="hideModal">
          <router-view/>
      </modal>
    </transition>

    <!-- </transition> -->
    <b-row class="mx-0">
      <box
        class="webCube"
        service-type="web"
        titulo="works.portfolio.contents.web.title"
        description="works.portfolio.contents.web.description"/>
      <box
        class="softCube"
        service-type="software"
        titulo="works.portfolio.contents.software.title"
        description="works.portfolio.contents.software.description"
      />
    </b-row>

    <b-row class="mx-0">
      <box
        class="appCube"
        service-type="app"
        titulo="works.portfolio.contents.app.title"
        description="works.portfolio.contents.app.description"
      />
      <box
        class="disenoCube"
        service-type="design"
        titulo="works.portfolio.contents.design.title"
        description="works.portfolio.contents.design.description"
      />
    </b-row>

  </div>
</template>

<script>
  import Box from '../components/Box.vue'
  import modal from '../components/Modal.vue'
  import WatchPortfolio from '../pages/WatchPortfolio.vue'

  export default {
    name: 'Portfolio',
    components: { Box, modal, WatchPortfolio },
    data () {
      return {
        showModal: false,
      }
    },
    props: {
      serviceType: {
        type: String,
        default: null,
      },
      serviceId: {
        type: Number
      }
    },
    watch: {
      serviceType: {
        handler: function (newVal) {
          this.$nextTick(function () {
            this.showModal = !!newVal
          })
        },
        immediate: true
      },
      showModal (newVal) {
        this.$emit('modal-visibility-changed', newVal)
      }
    },
    methods: {
      hideModal: function () {
        this.showModal = false
        this.$router.push({ name: 'Services' })
      }
    },
  }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import '../assets/styles/portfolio.scss';

  .portfolio{
    height: 100vh;
  }

  .row {
    height: 50vh;
    margin-left: 0px;
    @media (max-width: 767px) {
      flex-direction: column;
      height: 150vh;
    }

    .cube{
      background-repeat:no-repeat;
      background-size: cover;
      background-position: center;
      background-color: #9ea3a7;
      cursor: pointer;
      padding-left: 0;
      padding-right: 0;

      @media (max-width: 767px) {
        height: 50vh;
        border: 1px solid #dee2e6 !important;
      }
    }

    .webCube {
      @extend .cube;
      background-image: url('../assets/images/portfolio/webApokServicios.jpg');
    }

    .softCube {
      @extend .cube;
      background-image: url('../assets/images/portfolio/softwareApokServicios.jpg');
    }

    .appCube {
      @extend .cube;
      background-image: url('../assets/images/portfolio/appApokServicios.jpg');
    }

    .disenoCube {
      @extend .cube;
      background-image: url('../assets/images/portfolio/disenoApokServicios.jpg');
    }
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(100px);
    //opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Portfolio.vue